import { CustomerChargeProvider } from './enums'
import type { CreateCustomerBillingProfile } from 'src/interfaces/customer'

/**
 * Billing defaults for POST /v1/admin/partners, copied verbatim from the Retool app this screen
 * replaces.
 *
 * The backend requires `billingProfile` — `AdminPartnersService.createPartner` destructures it
 * without a guard, so omitting it is a 500 rather than a validation error — but no admin is
 * expected to type it. Retool sent these exact values, empty contact strings included, which is
 * why nothing here is invented: it is the existing production default, not placeholder content.
 *
 * `externalChargeProvider: 'stripe'` does mean the backend attempts to create a Stripe customer
 * (with the empty `emailAddress`). That call is wrapped in try/catch server-side and falls back to
 * ChargeProvider.MANUAL if it throws, so a failure degrades rather than breaking creation.
 */
export const CREATE_CUSTOMER_BILLING_DEFAULTS: CreateCustomerBillingProfile = {
  emailAddress: '',
  contactName: '',
  externalChargeProvider: CustomerChargeProvider.Stripe,
  billingPhone: '',
  plan: {
    monthlyAccessPriceInCents: 5000,
    chargeMethodForSimpleDelivery: 'fixed',
    costPerSimpleDeliveryInCents: 250,
    percentageChargeForScheduledJobs: 50,
    percentageChargeForCancelledJobs: 50,
    cancelWindowChargeTriggerInMinutes: 120,
    cartWheelInitialRecruitmentChargeInCents: 1500,
    cartWheelSuccessfulRecruitChargeInCents: 500,
    cartWheelJobCountChargeThreshold: 3,
    onfleetInitialRecruitmentChargeInCents: 10000,
    onfleetSuccessfulRecruitChargeInCents: 0,
    onfleetJobCountChargeThreshold: 0,
    fountainInitialRecruitmentChargeInCents: 5000,
    fountainSuccessfulRecruitChargeInCents: 0,
    fountainJobCountChargeThreshold: 0,
    genericInitialRecruitmentChargeInCents: 5000,
    genericSuccessfulRecruitChargeInCents: 0,
    genericJobCountChargeThreshold: 0,
  },
}
